import React, {
	createContext,
	useContext,
	useState,
	type ReactNode,
} from "react";

interface WorkspaceSidebarContextType {
	isCollapsed: boolean;
	setIsCollapsed: (collapsed: boolean) => void;
	toggleSidebar: () => void;
}

const WorkspaceSidebarContext = createContext<
	WorkspaceSidebarContextType | undefined
>(undefined);

const STORAGE_KEY = "workspace-sidebar-collapsed";

export function WorkspaceSidebarProvider({
	children,
}: {
	children: ReactNode;
}) {
	// console.log("running wokrspace sidebar provider");

	// Initialize from localStorage
	const [isCollapsed, setIsCollapsedState] = useState<boolean>(() => {
		const stored = localStorage.getItem(STORAGE_KEY);
		return stored === "true";
	});

	const setIsCollapsed = (collapsed: boolean) => {
		setIsCollapsedState(collapsed);
		// Persist in localStorage
		localStorage.setItem(STORAGE_KEY, String(collapsed));
	};

	const toggleSidebar = () => {
		setIsCollapsed(!isCollapsed);
	};

	return (
		<WorkspaceSidebarContext.Provider
			value={{
				isCollapsed,
				setIsCollapsed,
				toggleSidebar,
			}}
		>
			{children}
		</WorkspaceSidebarContext.Provider>
	);
}

export function useWorkspaceSidebar() {
	const context = useContext(WorkspaceSidebarContext);
	if (context === undefined) {
		throw new Error(
			"useWorkspaceSidebar must be used within a WorkspaceSidebarProvider",
		);
	}
	return context;
}
